import React from 'react';
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Navbar = ({ showForm, showBusesSection, toggleForm, toggleBusesSection }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    }

    const location = useLocation();

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-secondary " id='navbar'>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">Vehicle Tracking</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about">Admin</Link>
                        </li>
                    </ul>
                    {!localStorage.getItem('token') ? (
                        <form className="d-flex">
                            <Link className="btn btn-primary mx-1" to="/login" role="button">Login</Link>
                            <Link className="btn btn-primary mx-1" to="/signup" role="button">Signup</Link>
                        </form>
                    ) : (
                        <button onClick={handleLogout} className="btn btn-primary">Logout</button>
                    )}
                    {showForm && (
                        <button onClick={toggleForm} className="btn btn-primary mx-2">Add Bus</button>
                    )}
                    {showBusesSection && (
                        <button onClick={toggleBusesSection} className="btn btn-primary mx-2">Show Buses</button>
                    )}
                </div>
            </div>
        </nav>
    )
}

export default Navbar;
